import { FC, memo } from 'react';
import classNames from 'classnames';

import { useUiStoreSelector } from '@/data';
import { PAGE_ROUTES } from '@/constants';

import PopoverPanel from '../PopoverPanel';
import Container from '../Container/Container';
import {
  CustomSearchIcon,
  CustomSearchInput,
  SearchResultsBody,
} from './SearchHeader.components';
import { SearchProvider } from './context';

import styles from './searchheader.module.scss';

interface SearchHeaderInlineProps {
  className?: string;
  seeAllHref?: string;
}

const SearchHeaderInline: FC<SearchHeaderInlineProps> = memo(
  ({ className, seeAllHref = PAGE_ROUTES.SHOP }) => {
    const { is_search_open, setState } = useUiStoreSelector(['is_search_open']);

    const close = () => setState({ is_search_open: false });

    return (
      <SearchProvider>
        <div
          className={classNames(styles.search_header_inline, {
            [styles.search_header_inline__open]: is_search_open,
          })}
          data-search-open={is_search_open || undefined}
        >
          {!is_search_open ? (
            <CustomSearchIcon />
          ) : (
            <CustomSearchInput autoFocus inlineNav onClose={close} />
          )}
        </div>
        <PopoverPanel
          ariaLabel="Search products"
          className={classNames(
            styles.search__container,
            styles.embedded_input,
            className,
          )}
          ignoreOutsideClick
          isOpen={is_search_open}
          toggle={close}
        >
          <Container className={styles.search__body}>
            <SearchResultsBody inlineMode seeAllHref={seeAllHref} />
          </Container>
        </PopoverPanel>
      </SearchProvider>
    );
  },
);

SearchHeaderInline.displayName = 'SearchHeaderInline';

export default SearchHeaderInline;
